import type { SectionContent } from './types';

export const renderSections = (sections: SectionContent[]): JSX.Element => {
  return (
    <>
      {sections.map((section, index) => (
        <div key={index} className="mt-3">
          <h5>{section.title}</h5>
          <div>
            {(() => {
              const contentElements: JSX.Element[] = [];
              let currentTextGroup: string[] = [];

              section.content.forEach((item, itemIndex) => {
                if (item.type === 'text') {
                  currentTextGroup.push(item.text);
                  return;
                }

                if (currentTextGroup.length > 0) {
                  contentElements.push(
                    <p key={`text-group-${itemIndex}`} style={{ whiteSpace: 'pre-line' }}>
                      {currentTextGroup.join('\n')}
                    </p>,
                  );
                  currentTextGroup = [];
                }

                contentElements.push(
                  <ul key={itemIndex}>
                    {item.items.map((listItem, listIndex) => (
                      <li key={listIndex}>{listItem}</li>
                    ))}
                  </ul>,
                );
              });

              if (currentTextGroup.length > 0) {
                contentElements.push(
                  <p key="final-text-group" style={{ whiteSpace: 'pre-line' }}>
                    {currentTextGroup.join('\n')}
                  </p>,
                );
              }

              return contentElements;
            })()}
          </div>
        </div>
      ))}
    </>
  );
};
